import { NavBarLink } from '@common/components/layout/nav/NavBarLink';
import { useApp } from '@common/hooks';
import { FeatureFlags } from '@common/models/Enums';
import { AuthOperationUINames } from '@common/models/Enums/AuthOperationStrings';
import { useHospitalApp } from '@hospital/hooks';
import { observer } from 'mobx-react';
import React from 'react';
import { Accordion } from 'react-bootstrap';

export const AdminNavList = observer(() => {
    const hospitalAppStore = useHospitalApp();
    const { configuration } = useApp();
    const canEditAllCommunicationTemplates = configuration.HasUIFlag(AuthOperationUINames.UI_HospitalFlags_CanEditAllCommunicationTemplates)
    const canViewAdminReports =
        configuration.systemEnvironment === "DEVLOCAL"  // Are you browsing from localhost?
        || configuration.systemEnvironment === "DEVPETCO" // Are you browsing from dev.petpass.com?
        || configuration.fullName === "Rosanna Dubbs"; // Are you Ro?
    const canEditSmsCommunicationTemplates = configuration.hasFeatureFlag(FeatureFlags.InAppSms);

    return (<div className="left-sidebar-nav">
        <Accordion defaultActiveKey={hospitalAppStore.adminNavActiveKey}>
            <NavBarLink className="nav-item-single" name="Location Management" route="/admin/locations" />
            <NavBarLink className="nav-item-single" name="User Profiles" route="/admin/users" />

            <Accordion.Item eventKey="1" >
                <Accordion.Header onClick={() => hospitalAppStore.navAccordionToggled("1")}>Schedule Management</Accordion.Header>
                <Accordion.Body>
                    <NavBarLink name="Appointment Types" route="/admin/appointmentTypes" />
                </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey='2'>
                <Accordion.Header onClick={() => hospitalAppStore.navAccordionToggled("2")}>Hospital Communication Templates</Accordion.Header>
                <Accordion.Body>
                    {
                        canEditAllCommunicationTemplates &&
                        <NavBarLink name="Visit Templates" route="/admin/communicationtemplates" />
                    }
                    {
                        canEditSmsCommunicationTemplates &&
                        <NavBarLink name='SMS Templates' route='/admin/smstemplates' />
                    }
                </Accordion.Body>
            </Accordion.Item>

            {
                canViewAdminReports &&
                <Accordion.Item eventKey="3" >
                    <Accordion.Header onClick={() => hospitalAppStore.navAccordionToggled("3")}>Reports</Accordion.Header>
                    <Accordion.Body>
                        <NavBarLink name="Hospital Appointments" route="/admin/reports/hospitalAppointments" />
                    </Accordion.Body>
                </Accordion.Item>
            }
        </Accordion>
    </div>)
});

export default AdminNavList;
